export function extractDeepPropertyByMapKey(obj: any, map: string): any {
    if (map == "$index") {
        return obj.$index;
    }

    const keys = map.split('.');
    const key = keys.shift();

    return keys.reduce((prop: any, key: string) => {
        return !this.isUndefined(prop) && !this.isUndefined(prop[key])
            ? prop[key]
            : undefined;
    }, obj[key || '']);
}

export function isUndefined(value: any) {
    return typeof value === 'undefined';
}

export function isNumber(value: any) {
    return typeof value === 'number';
}

export function isString(value: any) {
    return typeof value === 'string';
}

export function isBoolean(value: any) {
    return typeof value === 'boolean';
}

export function isObject(value: any) {
    return value !== null && typeof value === 'object';
}

export function isNumberFinite(value: any) {
    return isNumber(value) && isFinite(value);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/helpers.ts